import React from 'react'
import fourFourMeasure from '../assets/fourFourMeasure.png'

export default function SimpleQuad() {
    return (
        <div>
            <img className="simpleQuad" src={fourFourMeasure} alt="simple quadruple meter" />
        </div>
    )
}